// extracted by mini-css-extract-plugin
module.exports = {"select":"Select_select__3UVD7","item":"Select_item__3Bd6z","item--active":"Select_item--active__33VmH","menu":"Select_menu__1P5nF"};